<template>
  <v-row>
    <v-col :cols="11">
      <CPTFormSubtitle label="Membros Familiares" />
    </v-col>
    <v-col cols="1">
      <CPTBtn
        icon="mdi-plus"
        tooltipText="Adicionar membro familiar"
        @click="showNewMemberInput = !showNewMemberInput"
        :rotateIcon="showNewMemberInput"
      />
    </v-col>
    <!-- Begin -> Alterar para a sessão Membros Familiares -->
    <v-col class="text-subtitle-1 font-weight-bold" cols="12">
      <span>
        {{ `Renda per capita: R$ ${inscricaoLocal.renda_percapta}` }}
      </span>
    </v-col>
    <!-- end -->
    <!-- Seção para adicionar membro familiar -->
    <v-expand-transition>
      <v-card
        v-if="showNewMemberInput"
        outlined
        class="d-flex flex-grow-1 flex-column"
      >
        <CPTFormMemberFamily
          v-model="newFamilyMember"
          showOnDialog
          showRendaField
        />
        <v-card-actions class="d-flex justify-end">
          <CPTBtn
            label="Adicionar Membro Familiar"
            icon="mdi-content-save"
            @click="onSaveNewFamilyMember"
            :loading="loadingBtn"
          />
        </v-card-actions>
      </v-card>
    </v-expand-transition>
    <!--  -->

    <v-col cols="12">
      <v-data-table
        hide-default-footer
        class="grey lighten-5"
        :items="inscricaoLocal.membroFamilia"
        :headers="[
          {
            sortable: false,
            text: 'Parentesco',
            value: 'parentesco.nome'
          },
          { sortable: false, text: 'Nome', value: 'nome' },
          { sortable: false, text: 'CPF', value: 'cpf' },
          {
            sortable: false,
            text: 'Certidão de Nascimento',
            value: 'certidao_nascimento'
          },
          { text: 'Ações', value: 'actions', sortable: false }
        ]"
        single-expand
        @click:row="
          (item, { isExpanded, expand }, event) =>
            expandTableItem(item, isExpanded, expand, event)
        "
        item-class="onhover"
      >
        <template v-slot:[`item.cpf`]="{ item }">
          {{ item.cpf && stringToCpf(item.cpf) }}
        </template>
        <template v-slot:[`item.certidao_nascimento`]="{ item }">
          {{
            item.certidao_nascimento === "0" || !item.certidao_nascimento
              ? " - "
              : item.certidao_nascimento
          }}
        </template>

        <template v-slot:expanded-item="{ headers, item: membro }">
          <td :colspan="headers.length" class="grey lighten-4">
            <v-row v-if="membro.renda && !membro.editing">
              <v-col
                cols="auto"
                class="d-flex align-center justify-center flex-grow-0 flex-shrink-1"
              >
                <span>
                  Local de trabalho:
                  {{ membro.local_trabalho || "Não informado" }}
                </span>
              </v-col>

              <v-col
                v-if="membro.local_trabalho"
                cols="auto"
                class="d-flex align-center justify-center flex-grow-1 flex-shrink-0 flex-column"
              >
                <span>
                  Horário de entrada:
                  {{ membro.horario_trabalho_inicio || "Não informado" }}
                </span>
                <span>
                  Horário de saída:
                  {{ membro.horario_trabalho_fim || "Não informado" }}
                </span>
              </v-col>

              <v-col
                cols="auto"
                class="d-flex align-center justify-center flex-grow-0 flex-shrink-1"
              >
                <span>Renda mensal: R$ {{ membro.renda }}</span>
              </v-col>
            </v-row>
            <v-row v-if="!membro.renda && !membro.editing">
              <v-col>
                Sem renda cadastrada
              </v-col>
            </v-row>
            <v-row v-if="membro.editing" class="d-flex align-center mt-4">
              <v-col
                cols="4"
                class="d-flex align-center justify-center flex-grow-0 flex-shrink-1"
              >
                <CPTInput
                  v-model="membro.local_trabalho"
                  dense
                  label="Local de trabalho"
                  class="d-flex align-center "
                ></CPTInput>
              </v-col>

              <v-col
                cols="2"
                class="d-flex align-center justify-center  flex-shrink-0 flex-column"
              >
                <CPTInput
                  v-model="membro.horario_trabalho_inicio"
                  dense
                  label="Entrada"
                  v-maska="'##:##'"
                ></CPTInput>
              </v-col>
              <v-col
                cols="2"
                class="d-flex align-center justify-center  flex-shrink-0 flex-column"
              >
                <CPTInput
                  v-model="membro.horario_trabalho_fim"
                  dense
                  label="Saída"
                  v-maska="'##:##'"
                ></CPTInput>
              </v-col>

              <v-col
                cols="4"
                class="d-flex align-center justify-center flex-grow-0 flex-shrink-1"
              >
                <CPTInput
                  dense
                  label="Renda mensal"
                  v-model="membro.renda"
                  prefix="R$"
                  v-maska="rendaMask"
                ></CPTInput>
              </v-col>
            </v-row>

            <v-row
              v-if="
                membro.endereco &&
                  membro.endereco.id !==
                    inscricaoLocal.matricula.pessoa.endereco.id
              "
            >
              <v-col cols="12" class="pb-0">
                Endereço:
                {{
                  `${membro.endereco.logradouro}, ${
                    membro.endereco.bairro
                  }, ${membro.endereco.numero || "S/N"} - ${
                    membro.endereco.cidade.nome
                  }/${membro.endereco.cidade.estado.sigla} `
                }}
              </v-col>
              <v-col v-if="membro.endereco.complemento" cols="12" class="pt-0">
                Complemento: {{ membro.endereco.complemento }}
              </v-col>
            </v-row>
          </td>
        </template>

        <template v-slot:[`item.actions`]="{ item, index }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                class="mr-2"
                color="primary"
                small
                v-on="on"
                :disabled="!isAdmin() && !isGestor()"
                @click="onUpdateFamilyMember(item, index)"
              >
                {{ item.editing ? "mdi-content-save" : "mdi-pencil" }}
              </v-icon>
            </template>
            <span>{{ item.editing ? "Salvar" : "Editar" }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                color="primary"
                small
                v-on="on"
                :disabled="item.editing && !isAdmin() && !isGestor()"
                @click="onDeleteFamilyMember(item, index)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import CPTFormMemberFamily from "../../../components/FormMemberFamily";
import CPTBtn from "@/components/Btn";
import CPTFormSubtitle from "@/components/FormSubtitle";
import CPTInput from "@/components/Input";
import FamilyMember from "@/models/FamilyMember";
import { isAdmin, isGestor } from "@/plugins/security";
import certidaoAntiga from "@/utils/certidaoAntiga";
import stringToCpf from "@/utils/stringToCpf";

export default {
  components: {
    CPTBtn,
    CPTFormMemberFamily,
    CPTFormSubtitle,
    CPTInput
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      newFamilyMember: new FamilyMember(),
      showNewMemberInput: false,
      itemEditableState: false,
      speedDialModel: false,
      loadingBtn: false,
      loading: false,
      valor: 0,
      rendaMask: ["#.###,##", "##.###,##", "###,##", "#,##"]
    };
  },

  computed: {
    inscricaoLocal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },

  methods: {
    isAdmin,
    isGestor,
    stringToCpf,

    expandTableItem(item, isExpanded, expand, event) {
      const diferentEditingItem = this.inscricaoLocal.membroFamilia.find(
        membro => membro.editing && membro.id !== item.id
      );

      if (diferentEditingItem) {
        this.$set(diferentEditingItem, "editing", false);
      }

      if (isExpanded && item.editing && event.target.nodeName === "BUTTON") {
        return;
      }

      if (isExpanded && item.editing && event.target.nodeName === "TD") {
        this.$set(item, "editing", false);
      }

      expand(!isExpanded);
    },

    createNewFamilyMember() {
      return {
        ...this.newFamilyMember,
        income:
          Number(
            this.newFamilyMember.income?.replace(".", "").replace(",", ".")
          ) || 0,
        endereco: this.newFamilyMember.endereco.isEmpty()
          ? this.inscricaoLocal.matricula.pessoa.endereco
          : this.newFamilyMember.endereco,
        certidaoNascimento:
          this.newFamilyMember.certidaoNascimento ||
          certidaoAntiga.certidaoNascimentoAntiga(this.newFamilyMember)
      };
    },

    onSaveNewFamilyMember() {
      const newFamilyMember = this.createNewFamilyMember();

      this.loadingBtn = true;
      this.$http
        .post(`inscricao/${this.inscricaoLocal.id}/membro-familia`, {
          ...newFamilyMember,
          endereco: {
            ...newFamilyMember.endereco,
            logradouro: newFamilyMember.endereco.rua,
            cidade_id: newFamilyMember.endereco.cidade.id
          }
        })
        .then(inscricao => {
          this.inscricaoLocal = inscricao;
          this.loadingBtn = false;
          this.showNewMemberInput = false;
          this.showMessage(
            `Membro familiar adicionado com sucesso!`,
            "success"
          );
        })
        .catch(error => {
          this.showMessage(error, "error");
          this.loadingBtn = false;
        });
    },

    onUpdateFamilyMember(membroFamiliar, index) {
      if (membroFamiliar.editing) {
        this.$set(this.inscricaoLocal.membroFamilia[index], "editing", false);
        this.loading = true;

        this.$http
          .put(
            `inscricao/${this.inscricaoLocal.id}/membro-familia/${membroFamiliar.id}`,
            {
              ...membroFamiliar,
              renda: membroFamiliar.renda.replace(".", "").replace(",", ".")
            }
          )
          .then(inscricao => {
            this.inscricaoLocal = inscricao;
            this.loading = false;
            this.showMessage(`Inscrição atualizada com sucesso!`, "success");
          })
          .catch(error => {
            this.showMessage(error, "error");
            this.loading = false;
          });
      } else {
        this.$set(this.inscricaoLocal.membroFamilia[index], "editing", true);
      }
    },

    onDeleteFamilyMember(membroFamiliar) {
      this.loading = true;
      this.$http
        .delete(
          `inscricao/${this.inscricaoLocal.id}/membro-familia/${membroFamiliar.id}`
        )
        .then(inscricao => {
          this.inscricaoLocal = inscricao;
          this.loading = false;
          this.showMessage(`Inscrição atualizada com sucesso!`, "success");
        })
        .catch(error => {
          this.showMessage(error, "error");
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
@keyframes rotateIcon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

.rotate {
  transform: rotate(45deg);
}
</style>
